import React, { Component } from "react";
import LocationsView from "./LocationsView";
import { history } from "../../../helpers";

export default class LocationsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: {}
    };
  }
  /**
   * @function  navigateToClinicDetails
   * @description This function redirect the user to clinic-details
   */
  navigateToClinicDetails = clinicId => {
    const { refreshClinicDetails } = this.props;

    refreshClinicDetails(clinicId);
    history.push(`/clinics-details/${clinicId}/basic-details`);
  };

  render() {
    const { details } = this.props;

    return (
      <>
        {details && (
          <LocationsView
            details={details}
            navigateToClinicDetails={this.navigateToClinicDetails}
          />
        )}
      </>
    );
  }
}
